import { NgModule } from '@angular/core';

import { DbModule } from '../../../../../shared/services/db/db.module';
import { DB_TYPE_ACTION_MAPPING } from '../../../../../shared/services/db/db.tokens';
import { XENA_SEARCH_MASK_MAPPING } from './searchmask.mapping';


@NgModule({
	imports: [ DbModule.forChild() ],
	providers: [{
		provide: DB_TYPE_ACTION_MAPPING,
		useValue: XENA_SEARCH_MASK_MAPPING,
		multi: true
	}]
})
export class SearchMaskModule {}



// WEBPACK FOOTER //
// ./src/app/xena/core/shared/mapping/searchmask/searchmask.module.ts